export default __webpack_public_path__ + "static/media/icon_arrow_right.1bc565e1.svg";